import { Fonts, Colors } from '../../src/config/theme';
import styled from 'styled-components';

export const Heading = styled.h1`
  margin-bottom: 13px;
  font-weight: bold;
  font-size: 18px;
  color: #002733;
`;

export const ThemeTabs = styled.div`
  .nav-pills {
    position: relative;
    margin-bottom: 10px;
    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      left: 0;
      right: 0;
      background-color: rgba(0, 39, 51, 0.05);
      height: 4px;
      width: 99%;
      border-radius: 4px;
    }
    .nav-item {
      cursor: pointer;
      a {
        position: relative;
        font-weight: 600;
        font-size: 14px;
        padding: 8px 14px;
        line-height: 140%;
        text-align: center;
        letter-spacing: -0.408px;
        color: #4c6870;
        margin: 0px;
        &.active {
          color: #002733;
          background-color: transparent;
          &:before {
            content: '';
            position: absolute;
            bottom: 0px;
            left: 0;
            right: 0;
            background-color: var(--theme-clr);
            height: 4px;
            width: 100%;
            border-radius: 4px;
          }
        }
      }
    }
  }
`;

const CardStyled = styled.div`
  background: #ffffff;
  box-shadow: 0px 5px 10px -2px rgba(196, 214, 220, 0.25);
  border-radius: 5px;
  padding: ${(props) => (props.padding ? props.padding : '20px')};
  margin-bottom: 20px;
  &.bg-grey {
    background-color: #e5eaeb;
  }
  &.bg-blue {
    background-color: #4c6870;
  }
  .head {
    padding: 20px 20px 15px;
    margin: -20px -20px 15px -20px;
    border-bottom: 1px solid rgba(0, 39, 51, 0.08);
    h1 {
      font-family: ${Fonts.primary};
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #002733;
      margin: 0;
    }
  }
  .head.no-border {
    border-bottom: none;
  }
  .checkBoxes {
    /* padding: 13px; */
    h6 {
      font-family: ${Fonts.secondary};
      font-style: normal;
      font-weight: 700;
      font-size: 12px;
      color: rgba(0, 39, 51, 0.5);
    }
  }
  .form-check-input:checked {
    background-color: #05ae4b;
  }
  .form-check {
    label {
      font-weight: 400;
      font-size: 15px;
      color: #002733;
    }
  }
  .used {
    padding-left: 39px;
  }

  .attr_name {
    line-height: 3;
    background: var(--grey-color);
    padding: 3px 10px;
  }
  .light-btn {
    background: var(--light-theme-clr);
    color: var(--theme-clr);
    padding: 9px 40px;
  }
  .one {
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    padding: 13px 0px 13px 28px;
    background: white;
  }
  .padd {
    padding-bottom: 7px;
  }
  .form-check-input:checked {
    background-color: #05ae4b;
  }
  .form-check-label {
    font-weight: 500;
    font-size: 17px;
  }
  .tracking_code_div {
    display: flex;
    /* border: 1px solid #000; */
    h5 {
      border: 1px solid var(--theme-clr);
      padding: 5px 10px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
`;

const Button = styled.button`
  background: ${(props) => (props.bg ? props.bg : '#05AE4B')};
  border-radius: 5px;
  border: ${(props) => (props.bg ? props.bg : 'none')};
  padding: 0 20px;
  min-width: 100px;
  width: ${(props) => props.width};
  height: ${(props) => (props.height ? props.height : '40px')};
  white-space: nowrap;
  color: ${(props) => (props.color ? props.color : 'white')};
  font-weight: 600;
  font-size: 15px;
  font-family: ${Fonts.secondary}, sans-serif;
  transition: 0.2s all;
  margin-bottom: ${(props) => props.mb};
  margin-top: ${(props) => props.mt};
  &:hover {
    background: '#CDEFDB';
    color: '#05AE4B';
    transform: scale(1.01);
  }
  &:disabled {
    background: rgba(90, 179, 168, 0.5);
    cursor: inherit;
    &:hover {
      transform: scale(1);
    }
  }
  &.grey {
    background: #ccd4d6;
    color: rgba(0, 39, 51, 0.5);
  }
  &.w-230 {
    width: 230px;
  }
  &.w-148 {
    width: 148px;
  }
  svg {
    margin-right: 10px;
  }
  &.delete {
    background-color: #de350b;
  }
  &.hover-fill {
    background-color: white;
    color: #05ae4b;
    border: 1px solid #05ae4b;
    &:hover {
      background-color: #05ae4b;
      color: white !important;
      svg {
        path {
          fill: white;
        }
      }
    }
  }
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 0px 20px 0px;
`;

const HeadingStyled = styled.h1`
  font-size: ${(props) => props.size && props.size};
  font-weight: ${(props) => props.weight && props.weight};
  color: ${(props) => (props.color ? props.color : '#002733')};
  margin: ${(props) => (props.margin ? props.margin : '0')};
  a {
    color: var(--theme-clr);
    text-decoration: none;
  }
`;

const Label = styled.label`
  font-family: ${Fonts.secondary}, sans-serif;
  font-weight: 600;
  font-size: ${(props) => (props.size ? props.size : '14px')};
  line-height: 120%;
  color: ${(props) => (props.color ? props.color : '#002733')};
  margin-bottom: 7px;
`;

const Input = styled.input`
  width: 100%;
  height: 39px;
  outline: none;
  border: ${(props) =>
    props.borderDanger ? '1px solid red' : '1px solid #e8e8e8'};
  border-radius: 5px;
  padding: 9px 15px 8px 10px;
  margin-bottom: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 130%;
  letter-spacing: -0.408px;
  color: #002733;
  &::placeholder {
    color: #ccd4d6;
  }
`;

const ThemeModal = styled.div`
  .modal-title {
    font-weight: 600;
    font-size: 18px;
    line-height: 27px;
    color: #414342;
    margin: 0;
  }
  .modal-header {
    padding: 20px 20px 15px 20px;
    border: none;
  }
  .modal-body {
    padding: 0 20px 15px 20px;
  }
  .modal-footer {
    padding: 0 20px 20px 20px;
    border: none;
  }
  .text {
    font-family: ${Fonts.secondary};
    font-weight: 400;
    font-size: 15px;
    line-height: 150%;
    color: #4c6870;
    margin: 0;
    span {
      color: #002733;
      font-weight: 500;
    }
  }
  .refusal-textarea {
    background: #f2f4f5;
    height: 126px;
    border: none;
  }
`;

export {
  CardStyled,
  Button,
  HeadingStyled,
  FlexContainer,
  Label,
  Input,
  ThemeModal,
};

export const TableStyled = styled.div`
  font-family: ${Fonts.secondary}, sans-serif;
  .h3 {
    font-size: 25px;
    font-weight: 700;
    color: #002733;
    font-family: ${Fonts.primary}, sans-serif;
  }
  button[data-testid] {
    background: #f2f4f5;
    border-radius: 50%;
    width: 28px;
    height: 28px;
    margin: auto;
  }
  &.modal-table {
    background: #fafafa;
    max-height: 228px;
    overflow-y: auto;
    padding: 14px;
    border-radius: 8px;
    .rdt_Table {
      padding: 0;
    }
    .rdt_TableHeadRow {
      min-height: 30px;
      height: 30px;
    }
    .rdt_TableRow {
      background: #fafafa;
      min-height: 42px;
    }
  }
  .rdt_Table {
    padding: 15px 20px 10px 20px;
    background: #ffffff;
    border-radius: 5px;
  }
  .rdt_TableHeadRow {
    background: #f2f4f5;
    box-shadow: 0px 1px 1px rgba(0, 39, 51, 0.25);
    border-radius: 5px;
  }
  .rdt_TableRow {
    border-color: rgba(0, 39, 51, 0.08);
    &:hover {
      background: rgba(90, 179, 168, 0.15);
    }
  }
  .rdt_TableRow.selected {
    background-color: rgba(
      90,
      179,
      168,
      0.15
    ); // Change the background color to red for selected row
  }
  .rdt_TableCol {
    font-weight: 700;
    font-size: 13px;
    padding: 10px;
  }
  .rdt_TableCell {
    padding-top: 8px;
    padding-bottom: 8px;
    font-size: 14px;
    font-weight: 400;
  }
  .rdt_Pagination {
    justify-content: inherit;
    background-color: var(--app-background-color);
    border-top: 0;
    font-size: 15px;
    color: #4c6870;
    button {
      &:disabled {
        pointer-events: none;
      }
      &:hover {
        background-color: #4c6870;
        svg {
          fill: white;
        }
      }
    }
    & > *:last-child {
      margin-left: auto;
    }
  }
  .stock-status {
    padding: 3px 9px;
    border-radius: 5px;
    font-weight: 500;
    font-size: 11px;
    color: white;
    min-height: 15px;
    display: block;
    &.low {
      background: #ffab00;
    }
    &.out {
      background: #ff5630;
    }
    &.bank {
      background: #fffae6;
      color: #ff8b00;
    }
    &.credit {
      background: #e6fcff;
      color: #008da6;
    }
  }
  .action-btn {
    border: none;
    background-color: transparent;
    padding: 0 10px;
    margin: 0 10px;
    &:hover {
      svg,
      path {
        fill: var(--theme-clr);
      }
    }
  }
  .table-product-img {
    height: 44px;
    width: 44px;
    border-radius: 4px;
  }
  .rdt_TableCell {
    &:last-child {
      div {
        overflow: visible !important;
      }
    }
  }
  .dropdown {
    overflow: visible !important;
    button {
      border: none !important;
      background-color: transparent !important;
      padding: 0 10px;
      margin: 0 10px;
      &::after {
        display: none;
      }
    }
  }
  input[type='checkbox'] {
    transform: scale(1.16);
  }

  .no-orders {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 60vh;
    img {
      width: 400px;
      height: 400px;
    }
    h3 {
      font-size: 25px;
      font-weight: 700;
      color: ${Colors.blueMain};
      padding: 10px;
    }
  }
`;

export const SanitizedHTMLStyle = styled.div`
  img {
    max-width: 100%;
    height: auto;
  }
  a {
    color: #00b074;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
`;
